import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { Button } from '../button';
export function RadioButton({ active = false, onPress, title, value, small = false, style, disabled, }) {
    /**
     * Methods
     */
    const handlePress = useCallback(() => {
        onPress === null || onPress === void 0 ? void 0 : onPress(value);
    }, [onPress, value]);
    /**
     * DOM
     */
    return (_jsx(Button, { label: title, size: small ? 'sm' : 'base', variant: active ? 'secondary' : 'tertiary', onPress: handlePress, style: style, disabled: disabled }));
}
